import styled from "styled-components";

export const DropDownContentWrapper = styled.div`
  position: absolute;
  left: 0px;
  width: 260px; 
  background: #FFFFFF;
  border: 1px solid #E3E3E3;
  box-sizing: border-box;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  z-index: 10;
  padding: 20px;
  padding-top: 8px;
  margin-top: 5px;
  max-height: calc(100vh - 200px);
  overflow: auto;

  display: flex;
  align-items: row;
  flex-wrap: wrap;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
  }
`;